import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Checklist } from '@models/checklist.model';
import { Company } from '@models/company.model';
import { FileItem } from '@models/file-item.model';
import { Product } from '@models/product.model';
import { PurchaseOrderDto, PurchaseOrderSubscriberModel } from '@app/models/purchase-order.model.dto';
import { SharedService } from '@services/shared.service';
import { CompanyService } from '@services/company.service';
import { from, of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { User } from '@models/user.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment';

@Component({
  selector: 'ngx-po-review-step',
  templateUrl: './po-review-step.component.html',
  styleUrls: ['./po-review-step.component.scss'],
})
export class PoReviewStepComponent implements OnInit {
  isRCDSS = environment.name === 'rcdss';
  @Input() purchaseOrderInfo: PurchaseOrderDto | any;
  @Input() products: Product[] = [];
  @Input() suppliers: Company[] = [];
  @Input() purchaseOrderFiles: FileItem[];
  @Input() checklist: Checklist;

  @Output() checklistChange: EventEmitter<Checklist> = new EventEmitter<Checklist>();
  @Output() shipDateChange: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() cancelDateChange: EventEmitter<Date> = new EventEmitter<Date>();

  priorities = this.sharedService.priorities();
  subscribers: PurchaseOrderSubscriberModel[];
  users: User[] = [];

  constructor(
    private sharedService: SharedService,
    private companyService: CompanyService,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {
    this.purchaseOrderInfo.supplier = this.suppliers.find(s => s.id === this.purchaseOrderInfo.supplier_id);
    this.purchaseOrderInfo.priority = this.priorities.find(p => p.id === this.purchaseOrderInfo.customer_priority);

    this.getUsersAvailable();
  }

  getUsersAvailable() {
    const supplierId = this.purchaseOrderInfo.supplier_id;
    this.companyService.users(this.purchaseOrderInfo.customer_id)
      .pipe(catchError(error => of([])))
      .pipe(
        concatMap(customerUsers => {
          from(customerUsers).subscribe(u => {
            u.organization_id = this.purchaseOrderInfo.customer_id;
          });
          return this.companyService.users(this.purchaseOrderInfo.supplier_id)
            .pipe(
              catchError(error => of([])),
              map(
                supplierUsers => [].concat(customerUsers, supplierUsers),
              ),
            );
        }),
      ).subscribe((users) => {
      from(users).subscribe(u => {
        if (u.organization_id === undefined) {
          u.organization_id = supplierId;
        }
        this.users = [...this.users, u];
      });
    });
  }

  getSubscribers() {
    if (!this.users || !this.purchaseOrderInfo?.subscribers) {
      return [];
    }
    return this.users.filter(u => this.purchaseOrderInfo.subscribers.find(s => s === u.id));
  }

  checklistChanged(checklist) {
    this.checklistChange.emit(checklist);
  }
}
